import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSmsFieldsContainer extends Layout {
    panelSmsFields: Panel;
    sourceCarrierDriverContacts: DataSource;
    sourceCarrierDriverMessage: DataSource;
    textboxCellPhoneNumber: Textbox;
    textboxDriverName: Textbox;
    textboxHours: Textbox;
    textboxRecurrenceTermination: Textbox;
    textboxResendFrequency: Textbox;
    textboxSendMessageDeliveryMode: Textbox;
}
